module.exports = __webpack_public_path__ + "static/media/PlutoRegular.7a51f88d.svg";